function About() {
  return (
    <div className="sections_group">
      <div id="Subheader" style={{ padding: "80px 0" }}>
        <div className="container">
          <div className="column one">
            <h3 className="title">Sterk in Technologie en Talent</h3>
          </div>
        </div>
      </div>

      <div className="entry-content">
        <div
          className="section mcb-section"
          style={{ paddingTop: 0, paddingBottom: 50 }}
        >
          <div className="section_wrapper mcb-section-inner">
            <div className="wrap mcb-wrap one  valign-top clearfix">
              <div className="mcb-wrap-inner">
                <div className="column mcb-column one column_divider">
                  <hr style={{ margin: "0 auto 70px" }} />
                </div>
                <div className="column mcb-column one column_column ">
                  <div
                    className="column_attr align_center"
                    style={{ padding: "0 7%" }}
                  >
                    <h4 className="themecolor">
                      Bij App Makelaar bieden we maatwerk in websites, apps,
                      tekstschrijven en chatbots, gericht op kleine bedrijven.
                      We streven ernaar om onafhankelijkheid van grote
                      platformen te bevorderen. We kenmerken ons door snelle,
                      flexibele oplossingen met een uitstekende
                      prijs-kwaliteitverhouding en bieden langdurige
                      ondersteuning voor digitale groei.
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="wrap mcb-wrap one-third  valign-top clearfix"
              style={{ padding: "0 1%" }}
            >
              <div className="mcb-wrap-inner">
                <div className="column mcb-column one column_image">
                  <div className="image_frame image_item scale-with-grid aligncenter no_border">
                    <div className="image_wrapper">
                      <a href="designers.html">
                        <div className="mask" />
                        <img
                          className="scale-with-grid"
                          src="content/architect2/images/home_architect2_team3.jpg"
                          width={780}
                          height={520}
                        />
                      </a>
                      <div className="image_links">
                        <a href="designers.html" className="link">
                          <i className="icon-link" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column mcb-column one column_column ">
                  <div className="column_attr" style={{ padding: "0 10% 0 0" }}>
                    <h4 style={{ marginLeft: 30 }}>Wie zijn we?</h4>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div className="image_frame image_item no_link scale-with-grid alignnone no_border">
                      <div className="image_wrapper">
                        <img
                          className="scale-with-grid"
                          src="content/architect2/images/home_architect2_sep.png"
                          width={100}
                          height={3}
                        />
                      </div>
                    </div>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div style={{ marginLeft: 30 }}>
                      <h6>Technologie is onze passie</h6>
                      <p>
                        Welkom bij App Makelaar, een dynamisch bedrijf opgericht
                        door twee beste vrienden met een gedeelde passie voor
                        innovatie en technologie. Gevestigd in Nederland en met
                        een breed netwerk in Latijns Amerika, combineren we het
                        beste van twee werelden om unieke digitale oplossingen
                        te bieden. Ons team, bestaande uit experts met een
                        IT-achtergrond, is toegewijd aan het transformeren van
                        bedrijven door middel van geavanceerde automatisering en
                        digitale diensten.
                      </p>
                      <p>
                        Ons bedrijf is stellig van mening dat het midden- en
                        kleinbedrijf (MKB) de drijvende kracht is achter de
                        economie. Deze kleinere ondernemingen brengen innovatie,
                        creëren banen en stimuleren de lokale gemeenschappen.
                        Onze passie ligt in het ondersteunen van deze bedrijven.
                        We zijn intrinsiek gemotiveerd om hen te helpen vanuit
                        een perspectief van verantwoord ondernemen. Dit doen we
                        door het bieden van op maat gemaakte IT-oplossingen die
                        niet alleen hun bedrijfsvoering efficiënter maken, maar
                        ook bijdragen aan hun duurzame groei. Door samen te
                        werken met deze ondernemingen, geloven wij dat we een
                        positieve impact kunnen hebben op de bredere economie en
                        de samenleving als geheel.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="wrap mcb-wrap one-third  valign-top clearfix"
              style={{ padding: "0 1%" }}
            >
              <div className="mcb-wrap-inner">
                <div className="column mcb-column one column_image">
                  <div className="image_frame image_item scale-with-grid aligncenter no_border">
                    <div className="image_wrapper">
                      <a href="designers.html">
                        <div className="mask" />
                        <img
                          className="scale-with-grid"
                          src="content/architect2/images/home_architect2_team1.jpg"
                          width={780}
                          height={520}
                        />
                      </a>
                      <div className="image_links">
                        <a href="designers.html" className="link">
                          <i className="icon-link" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column mcb-column one column_column ">
                  <div className="column_attr" style={{ padding: "0 10% 0 0" }}>
                    <h4 style={{ marginLeft: 30 }}>Wat doen we?</h4>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div className="image_frame image_item no_link scale-with-grid alignnone no_border">
                      <div className="image_wrapper">
                        <img
                          className="scale-with-grid"
                          src="content/architect2/images/home_architect2_sep.png"
                          width={100}
                          height={3}
                        />
                      </div>
                    </div>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div style={{ marginLeft: 30 }}>
                      <h6>Voor elk probleem vinden we een oplossing.</h6>
                      <p>
                        Bij App Makelaar specialiseren we ons in het creëren van
                        op maat gemaakte websites en apps, het schrijven en
                        vertalen van teksten, het inrichten van chatbots, en het
                        leveren van maatwerkoplossingen. We richten ons op het
                        ondersteunen van het klein mkb, waarbij we onze
                        expertise gebruiken om bedrijven te helpen bij hun
                        automatiseringsbehoeften. Ons doel is om bedrijven
                        minder afhankelijk te maken van grote platformen, door
                        ze te voorzien van hun eigen, zelfstandige websites en
                        digitale tools.
                      </p>
                      <p>
                        Onze benadering is persoonlijk en klantgericht, waarbij
                        we nauw samenwerken met onze cliënten om hun specifieke
                        behoeften te begrijpen en oplossingen te bieden die daar
                        naadloos op aansluiten. We streven ernaar om niet alleen
                        technologische hulpmiddelen te leveren, maar ook
                        strategisch advies te bieden om de online aanwezigheid
                        en operationele efficiëntie van onze klanten te
                        verbeteren. Ons netwerk bestaat uit ervaren
                        ontwikkelaars, ontwerpers, content creators en
                        marketingexperts die allemaal hetzelfde doel voor ogen
                        hebben: het realiseren van een digitale transformatie
                        die echte waarde toevoegt aan uw bedrijf. Met App
                        Makelaar kiest u voor een partner die zich inzet voor uw
                        succes in het digitale tijdperk.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="wrap mcb-wrap one-third  valign-top clearfix"
              style={{ padding: "0 1%" }}
            >
              <div className="mcb-wrap-inner">
                <div className="column mcb-column one column_image">
                  <div className="image_frame image_item scale-with-grid aligncenter no_border">
                    <div className="image_wrapper">
                      <a href="designers.html">
                        <div className="mask" />
                        <img
                          className="scale-with-grid"
                          src="content/architect2/images/home_architect2_team2.jpg"
                          width={780}
                          height={520}
                        />
                      </a>
                      <div className="image_links">
                        <a href="designers.html" className="link">
                          <i className="icon-link" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="column mcb-column one column_column ">
                  <div className="column_attr" style={{ padding: "0 10% 0 0" }}>
                    <h4 style={{ marginLeft: 30 }}>Wat bieden we?</h4>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div className="image_frame image_item no_link scale-with-grid alignnone no_border">
                      <div className="image_wrapper">
                        <img
                          className="scale-with-grid"
                          src="images/home_architect2_sep.png"
                          width={100}
                          height={3}
                        />
                      </div>
                    </div>
                    <hr className="no_line" style={{ margin: "0 auto 20px" }} />
                    <div style={{ marginLeft: 30 }}>
                      <h6>Topkwaliteit voor een zeer scherpe prijs.</h6>
                      <p>
                        App Makelaar staat voor snelheid, flexibiliteit, en
                        uitstekende prijs-kwaliteitverhouding. Ons breed
                        gespecialiseerde team kan snel schakelen om oplossingen
                        op maat te bieden die naadloos aansluiten op de unieke
                        behoeften van elk bedrijf. Wij zijn er trots op dat wij
                        complexe technologie toegankelijk en waardevol kunnen
                        maken voor kleine en middelgrote ondernemingen. Met App
                        Makelaar als uw partner, vindt u een toegewijde
                        bondgenoot in het streven naar onafhankelijkheid van
                        grote platformen, met een persoonlijke aanpak en een
                        onwrikbare toewijding aan kwaliteit.
                      </p>
                      <p>
                        Bovendien begrijpen we dat elk bedrijf zijn eigen
                        verhaal en achtergrond heeft. Daarom zorgen we ervoor
                        dat onze oplossingen niet alleen technisch effectief
                        zijn, maar ook nauw aansluiten bij de cultuur en
                        identiteit van uw bedrijf. We werken nauw samen met onze
                        klanten om hun merk en waarden te weerspiegelen in de
                        digitale ruimte, of het nu gaat om een website, app of
                        een geïntegreerde marketingstrategie. Dit maatwerk
                        benadrukt de unieke kwaliteiten van uw onderneming en
                        helpt u zich te onderscheiden in een competitieve markt.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="section mcb-section"
          style={{
            paddingTop: 60,
            paddingBottom: 20,
            backgroundColor: "#b8a892",
          }}
        >
          <div className="section_wrapper mcb-section-inner">
            <div className="wrap mcb-wrap one  valign-top clearfix">
              <div className="mcb-wrap-inner">
                <div className="column mcb-column three-fifth column_column ">
                  <div className="column_attr">
                    <h2 style={{ margin: 0 }}>Heeft u een vraag?</h2>
                  </div>
                </div>
                <div className="column mcb-column two-fifth column_column ">
                  <div
                    className="column_attr align_right"
                    style={{
                      padding: "10px 5px",
                      borderBottom: "1px solid rgba(0,0,0,.2)",
                    }}
                  >
                    <a
                      style={{ color: "#635f5e" }}
                      href="mailto:info@appmakelaar.nl"
                    >
                      Neem contact met ons op <i className="icon-right-open" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default About;
